var _line, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartB(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 67,
    viewBox: "0 0 65 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.36035,
    y1: 39.0254,
    x2: 64.2627,
    y2: 39.0254,
    stroke: "#828282",
    strokeWidth: 1.09765,
    strokeLinecap: "round",
    strokeDasharray: "2.2 2.2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25293 39.492C6.86724 29.026 8.78277 6.82501 11.5304 1.74861C11.5583 1.44645 11.8152 2.01232 12.6194 6.69316C13.3733 16.0054 14.8644 35.6023 14.7974 39.492C15.2721 46.744 16.6739 62.1215 18.4833 65.6157C18.7625 65.8904 19.5723 65.4509 20.5775 61.4952C21.7224 53.7213 24.632 37.7284 27.1116 35.9484C28.2564 34.7397 30.7472 33.8552 31.5514 39.9865C31.7747 41.9643 32.6571 45.854 34.3995 45.5903C35.0138 45.6727 36.8624 44.5025 39.3419 39.1624C40.2913 37.4318 43.0278 35.2232 46.3786 40.2337C48.1936 42.5686 53.0969 45.8375 58.1901 40.2337",
    stroke: "#66FCF1",
    strokeWidth: 2.1953,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartB);
export default __webpack_public_path__ + "static/media/chartB.a71897ba44dd660b82b931ade0140fb2.svg";
export { ForwardRef as ReactComponent };